import React, { useState, useEffect } from "react";

// import logo
import Logo from "../assets/img/logo.png";

// icones
import { CgMenuRight } from "react-icons/cg";

// nav bar
import Nav from "./Nav";
import NavMobile from "./NavMobile";
// import Program from "./Program";

const Header = () => {
  const [bg, setBg] = useState(false);
  const [navMobile, setNavMobile] = useState(false);

  // evento de scroll
  useEffect(() => {
    window.addEventListener("scroll", () => {
      window.scrollY > 50 ? setBg(true) : setBg(false);
    });
  });

  return (
    <header
      className={`${
        bg ? "bg-white py-3 shadow-md" : "bg-none py-5"
      } fixed w-full right-0 left-0 z-10 transition-all duration-300`}
    >
      .
      <div className="container mx-auto flex justify-between items-center">
        <a href="/">
          <img src={Logo} alt="" width={80} height={80} />
        </a>

        <div className="hidden lg:flex">
          <Nav />
        </div>

       

        <div className="lg:hidden cursor-pointer" onClick={() => setNavMobile(!navMobile)}>
          <CgMenuRight className="text-orange text-3xl" />
        </div>

        <div className={`${navMobile ? 'max-h-[250px]' : 'max-h-0'} 
        fixed bg-orange shadow-lg left-0 w-full h-full top-[120px]
        overflow-hidden transition-all
        `}>
          <NavMobile />
        </div>
      </div>
    </header>
  );
};

export default Header;
